export function createAggregatedTimer(data) {
    return {
        //Used by the ProductTimer component
        minutes: data.totalTargetMinutes,
        remainingSeconds: null,
        finished: false,
        paused: false,
        previousSeconds: data.totalPreviousSeconds,

        //Used by the containing component
        products: data.products,
    };
}
